import IconButton from 'components/atoms/button/IconButton'
import Form from 'components/atoms/form/Form'
import Input from 'components/atoms/input/Input'
import TextArea from 'components/atoms/text-area/TextArea'
import withModal from 'lib/helpers/hoc/withModal'
import { useCreateOrderRequest } from 'lib/hooks/mutations/Employee/useCreateOrderRequest'
import React, { FC } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'


interface IProps {
    onConfirm: () => void
}

const CreateOrderRequest: FC<IProps> = ({ onConfirm }) => {

    const { t } = useTranslation()

    const {
        handleSubmit,
        reset,
        register,
        formState: { errors }

    } = useForm({
        defaultValues: {
            product_name: "",
            comment: "",
        }
    })

    const { id } = useParams()

    const { mutateAsync, isLoading } = useCreateOrderRequest()

    const SubmitLeaveRequest = (data: any) => {
        const dataWithId = {
            ...data,
            id: id
        }
        mutateAsync(dataWithId).then(() => {
            onConfirm()
        })
    }

    return (
        <Form className='grid gap-5 grid-cols-1' onSubmit={handleSubmit(SubmitLeaveRequest)}>
            <Input
                label={t("Type")}
                placeholder={t("Choose Type")}
                {...register("product_name", { required: t("This field is required") })}
                error={errors.product_name}
            />

            <TextArea
                label={t("Comment")}
                placeholder={t("Write a comment")}
                {...register("comment", { required: t("This field is required") })}
                error={errors.comment}
            />

            <div className="pt-5 flex justify-end gap-4">
                <IconButton type='button' secondary onClick={() => { reset() }} className='min-w-[120px]' disabled={isLoading}>
                    {t('Reset')}
                </IconButton>
                <IconButton className='min-w-[120px]' disabled={isLoading}>
                    {t('Submit')}
                </IconButton>
            </div>
        </Form>
    )
}

export default withModal(CreateOrderRequest)
